export enum DividendType {
    INTERIM = "INTERIM",
    FINAL = "FINAL",
    SPECIAL = "SPECIAL"
}

export function dividendTypeName(type: DividendType): string {
    switch (type) {
        case DividendType.INTERIM:
            return "Interim";
        case DividendType.FINAL:
            return "Final";
        case DividendType.SPECIAL:
            return "Special";
    }
}
